import { createSlice } from '@reduxjs/toolkit'
import { logOut } from '../authentication/authenticationSlice';
import { getContract, getContractByCaseId } from '../contract/thunks';

const initialState = {
  caseForms: {},
  loading: "idle",
  error: null
}


const caseFormsSlice = createSlice({
  name: 'caseForms',
  initialState,
  reducers: {
    setFormAppointmentProperty:(state,action)=>{
      state.caseForms.formAppointment = {...state.caseForms.formAppointment, ...{[action.payload.main]: action.payload.value}};
    },
    setFormAppointment:(state,action)=>{ 
      state.caseForms.formAppointment = action.payload;
    },
    setFormDocumentationProperty:(state,action)=>{
      state.caseForms.formDocumentation = {...state.caseForms.formDocumentation, ...{[action.payload.main]: action.payload.value}};
    },
    setFormDocumentation:(state,action)=>{ 
      state.caseForms.formDocumentation = action.payload;
    },
    setFormClaimsProperty:(state,action)=>{
      state.caseForms.formClaims = {...state.caseForms.formClaims, ...{[action.payload.main]: action.payload.value}};
    },
    setFormClaims:(state,action)=>{
      state.caseForms.formClaims = action.payload;
    },
    setFormInformationProperty:(state,action)=>{
      state.caseForms.formInformation = {...state.caseForms.formInformation, ...{[action.payload.main]: action.payload.value}};
    },
    setFormInformation:(state,action)=>{
      state.caseForms.formInformation = action.payload;
    },
    setFormTerminationsProperty:(state,action)=>{
      state.caseForms.formTerminations = {...state.caseForms.formTerminations, ...{[action.payload.main]: action.payload.value}};
    },
    setFormTerminations:(state,action)=>{
      state.caseForms.formTerminations = action.payload;
    },
    setFormSubstitutionVehicleProperty:(state,action)=>{
      state.caseForms.formSubstitutionVehicle = {...state.caseForms.formSubstitutionVehicle, ...{[action.payload.main]: action.payload.value}};
    },
    setFormSubstitutionVehicle:(state,action)=>{
      state.caseForms.formSubstitutionVehicle = action.payload;
    },
    setFormDeliveryProperty:(state,action)=>{
      state.caseForms.formDelivery = {...state.caseForms.formDelivery, ...{[action.payload.main]: action.payload.value}};
    },
    setFormDelivery:(state,action)=>{
      state.caseForms.formDelivery = action.payload;
    },
    setFormOtherProperty: (state, action) =>{
      state.caseForms.formOther= {...state.caseForms.formOther, ...{[action.payload.main]: action.payload.value}};
    },
    setFormOther:(state,action)=>{
      state.caseForms.formOther = action.payload;
    },
    setFormOvcProperty: (state, action) =>{
      state.caseForms.formOvc= {...state.caseForms.formOvc, ...{[action.payload.main]: action.payload.value}};
    },
    setFormOvc:(state,action)=>{
      state.caseForms.formOvc = action.payload;
    },
    setFormItvProperty: (state, action) =>{
      state.caseForms.formItv= {...state.caseForms.formItv, ...{[action.payload.main]: action.payload.value}};
    },
    setFormItv:(state,action)=>{
      state.caseForms.formItv = action.payload;
    },
    setFormFuelCardProperty: (state, action) =>{
      state.caseForms.formFuelCard= {...state.caseForms.formFuelCard, ...{[action.payload.main]: action.payload.value}};
    },
    setFormFuelCard:(state,action)=>{
      state.caseForms.formFuelCard = action.payload;
    },
    setFormMarshProperty: (state, action) =>{
      state.caseForms.formMarsh= {...state.caseForms.formMarsh, ...{[action.payload.main]: action.payload.value}};
    },
    setFormMarsh:(state,action)=>{
      state.caseForms.formMarsh = action.payload;
    },
    setFormLetterQuery:(state,action)=>{
      state.caseForms.formLetterQuery = action.payload;
    },
    setFormLetterQueryProperty: (state, action) =>{
      state.caseForms.formLetterQuery= {...state.caseForms.formLetterQuery, ...{[action.payload.main]: action.payload.value}};
    },
    setFormResidentCard:(state,action)=>{
      state.caseForms.formResidentCard = action.payload;
    },
    setFormResidentCardProperty: (state, action) =>{
      state.caseForms.formResidentCard= {...state.caseForms.formResidentCard, ...{[action.payload.main]: action.payload.value}};
    },
  },
  extraReducers: {
    [logOut]: (state)=> initialState,
    [getContract.fulfilled]: (state) => initialState,
    [getContractByCaseId.fulfilled]: (state)=> initialState
  }
})

export const { setFormAppointmentProperty,
               setFormAppointment, setFormDocumentationProperty, setFormDocumentation, setFormClaimsProperty,
                setFormClaims, setFormInformation, setFormInformationProperty,setFormTerminations,setFormTerminationsProperty,
                setFormSubstitutionVehicle,setFormSubstitutionVehicleProperty, setFormDeliveryProperty,
                setFormDelivery, setFormOtherProperty, setFormOther, setFormOvcProperty, setFormOvc, 
                setFormItvProperty, setFormItv, setFormFuelCard, setFormFuelCardProperty, setFormMarsh, setFormMarshProperty,setFormLetterQuery, setFormLetterQueryProperty, setFormResidentCard, setFormResidentCardProperty} = caseFormsSlice.actions;

export default caseFormsSlice.reducer